import { Injectable } from '@angular/core';

/**
 * Service to preload images for better user experience
 */
@Injectable({
  providedIn: 'root',
})
export class ImagePreloaderService {
  private preloadedImages = new Set<string>();

  /**
   * Preload a single image
   */
  preloadImage(url: string): Promise<void> {
    if (this.preloadedImages.has(url)) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        this.preloadedImages.add(url);
        resolve();
      };

      img.onerror = () => {
        console.warn(`Failed to preload image: ${url}`);
        reject(new Error(`Failed to preload image: ${url}`));
      };

      img.src = url;
    });
  }

  /**
   * Preload multiple images
   */
  preloadImages(urls: string[]): Promise<void[]> {
    return Promise.all(urls.map(url => this.preloadImage(url)));
  }

  /**
   * Check if image is already preloaded
   */
  isPreloaded(url: string): boolean {
    return this.preloadedImages.has(url);
  }

  /**
   * Clear preloaded images cache
   */
  clearCache(): void {
    this.preloadedImages.clear();
  }
}
